import {
  SET_CULTURES_SUCCESS,
  SET_SHOW_ENTITIES,
  GET_GS_MODULE_ACTIVE_SUCCESS,
} from "../types/actionTypes";

const INIT_STATE = {
  cultures: [],
  constants: {},
  gsModuleActive: false,
  showEntities: false,
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case SET_CULTURES_SUCCESS:
      return { ...state, cultures: payload };
    case SET_SHOW_ENTITIES:
      return { ...state, showEntities: payload };
    case GET_GS_MODULE_ACTIVE_SUCCESS:
      return { ...state, gsModuleActive: payload };
    default:
      return { ...state };
  }
};
